module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/logo_sct_new.71e16e18.png";